export enum SignInStatus {
  Success,
  GeneralError,
  InvalidEmail,
  MissingPassword,
  InvalidCredentials,
  UserNotConfirmed,
  PasswordChangeRequired,
  Timeout,
}

export enum RespondToAuthChallengeStatus {
  Success,
  GeneralError,
  InvalidSession,
  UserNotFound,
  ExpiredCode,
  InvalidPassword,
}

export type SignInResult = {
  status: SignInStatus;
  tokens?: {
    idToken?: string;
    accessToken?: string;
    refreshToken?: string;
  };
  session?: string;
};

export type RespondToAuthChallengeResult = {
  status: RespondToAuthChallengeStatus;
  tokens?: {
    idToken?: string;
    accessToken?: string;
    refreshToken?: string;
  };
  session?: string;
};
